import Icon from 'veui/components/Icon'
import { IconUploadDesktop } from 'dls-icons-vue'

Icon.register('upload-desktop', IconUploadDesktop)
